// extracted by mini-css-extract-plugin
export var avatar = "_po-3";
export var avatarContainer = "_po-2";
export var avatarSpacer = "_po-5";
export var avatarSpacerContainer = "_po-4";
export var avatarStackContainer = "_po-1";
export var bubble = "_po-0";
export var remainderBubble = "_po-6";